// *******~ Import ~******** //
// React
import React, {
  useState,
  createContext,
  useContext,
  useEffect,
  useMemo,
} from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import closeiconnew from "./img/closebuttonimage.png";

// Assets

import { Container, Row, Col, Card, Button, Modal } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper";
// Components
// import ListSkeleton from "./listskeleton";
// import Sidebar from "./sidebar";
// import FilterList from "./filterlist";
import { OrderFlow } from "../../App";
// CSS
import "./css/listpage.scss";
// Images
// Icons

import Showcart from "../showcart/showcart";

// Redux home page code
import { connect, useDispatch } from "react-redux";
import { getListpage } from "../../actions/restaurant/listpageActions";
import {
  getCuisines,
  getCuisinesClear,
} from "../../actions/restaurant/listcuisinesAction";
import { lazy } from "react";
import Loadable from "../../router/loadable";
import {
  getFilter,
  getFilterClear,
} from "../../actions/restaurant/listfilterAction";
import { getListPageClear } from "../../actions/restaurant/listpageActions";
import { getOrderTimingDetail } from "../checkout/checkoutV2";
import moment from "moment";
//Lazy
const ListSkeleton = Loadable(lazy(() => import("./listskeleton")));
const Sidebar = Loadable(lazy(() => import("./sidebar")));
const FilterList = Loadable(lazy(() => import("./filterlist")));

// *******~ Import ~******** //
export const ContextWidthProvider = createContext({});
export const ContextWidthConsumer = () => useContext(ContextWidthProvider);

const EstimateModal = ({
  estimateShow,
  setEstimateShow,
  selectedTime,
  setSelectedTime,
  selectEstimateTime,
  setSelectEstimateTime,
  setGetOrderType,
}) => {
  const { getOrderMode } = OrderFlow();
  const { setTabStatus, setSelectimeStatus } = useContext(ContextWidthProvider);
  const [isLoadingTimes, setIsLoadingTimes] = useState(true);

  const generateTimeSlots = (start, end, interval = 5) => {
    const slots = [];
    let time = moment(start, "HH:mm");
    const endTime = moment(end, "HH:mm");

    while (time <= endTime) {
      slots.push(time.format("HH:mm"));
      time.add(interval, "minutes");
    }

    return slots.join(",");
  };

  const getNextSlotTime = () => {
    const now = moment();
    const minutes = Math.ceil(now.minutes() / 5) * 5;
    return now.clone().minutes(minutes).seconds(0);
  };

  const generateWeekSchedule = () => {
    const today = moment();
    const later = {};

    for (let i = 1; i <= 6; i++) {
      const date = moment(today).add(i, "days").format("YYYY-MM-DD");
      later[date] = generateTimeSlots("08:55", "23:59", 5);
    }

    const startToday = getNextSlotTime().format("HH:mm");
    const todaySlots = generateTimeSlots(startToday, "23:59", 5);

    return {
      Delivery: {
        today: todaySlots,
        asap: "",
        later,
      },
      Collection: {
        today: todaySlots,
        asap: "",
        later,
      },
    };
  };

  const preOrderTimeTable = generateWeekSchedule();

  const handleEstimateClose = () => {
    setEstimateShow(false);
  };
  //states
  const [estimateError, setEstimateError] = useState(false);
  const isDeliveryTodayEmptyOrNoPreorder =
    preOrderTimeTable?.Delivery?.today === "" ||
    preOrderTimeTable?.Delivery?.today == "No Pre-order" ||
    preOrderTimeTable?.Delivery?.today == "closed";
  const deliveryTimesToday = !isDeliveryTodayEmptyOrNoPreorder
    ? preOrderTimeTable?.Delivery?.today
    : "";
  const isCollectionTodayEmptyOrNoPreorder =
    preOrderTimeTable?.Collection?.today === "" ||
    preOrderTimeTable?.Collection?.today == "No Pre-order" ||
    preOrderTimeTable?.Collection?.today == "closed";
  const collectionTimesToday = !isCollectionTodayEmptyOrNoPreorder
    ? preOrderTimeTable?.Collection?.today
    : "";
  console.log('collectionTimesToday == ""', preOrderTimeTable);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoadingTimes(false);
    }, 1000); // 5 seconds

    return () => clearTimeout(timer); // Cleanup
  }, []);

  const handleScheduleChange = () => {
    const scduleType = selectEstimateTime == "today" ? "Today" : "Later";
    console.log(scduleType);
    setGetOrderType(scduleType);
    setSelectimeStatus(false);
    console.log(selectEstimateTime, selectedTime);
    localStorage.setItem("orderType", scduleType);
    setTabStatus(scduleType);
    const dateZone = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    };

    let formatToday = new Date()
      ?.toLocaleString("en-GB", dateZone)
      .replace(",", "");

    const dateString = formatToday?.replaceAll("/", "-");
    const parts = dateString?.split("-"); // Split the string by '-'
    let formattedDate = `${parts[2]}-${parts[1]}-${parts[0]} ${selectedTime}`;

    function midNightTimeCheck() {
      // Define the current date and time
      let userSelectDateStr = `${selectEstimateTime} ${selectedTime}`;
      let currentDate =
        selectEstimateTime == "today"
          ? new Date(formattedDate)
          : new Date(userSelectDateStr);
      let formatDateSplit =
        selectEstimateTime == "today"
          ? formattedDate?.split(" ")[0]
          : selectEstimateTime;

      // Define the start and end of the time range on June 5, 2024
      // const startRange = new Date(`${formatDateSplit} 00:00:00 GMT+0530`);
      // const endRange = new Date(`${formatDateSplit} 07:55:00 GMT+0530`);
      const startRange = new Date(`${formatDateSplit} T00:00:00+01:00`);
      const endRange = new Date(`${formatDateSplit} T07:55:00+01:00`);

      // Function to format date as 'YYYY-MM-DD HH:mm:ss'
      function formatDate(date) {
        let year = date.getFullYear();
        let month = String(date.getMonth() + 1).padStart(2, "0");
        let day = String(date.getDate()).padStart(2, "0");
        let hours = String(date.getHours()).padStart(2, "0");
        let minutes = String(date.getMinutes()).padStart(2, "0");
        let seconds = String(date.getSeconds()).padStart(2, "0");
        return `${year}-${month}-${day} ${hours}:${minutes}`;
      }

      // Check if the current date falls within the specified range
      if (currentDate >= startRange && currentDate <= endRange) {
        // Set the date to tomorrow at the same time
        const tomorrow = new Date(currentDate);
        tomorrow.setDate(tomorrow.getDate());
        // tomorrow.setDate(tomorrow.getDate() + 1);
        console.log(
          "Current date and time fall within the range. Setting date to tomorrow: " +
            formatDate(tomorrow)
        );
        const midNightTime = formatDate(tomorrow);
        return midNightTime;
      }
    }

    if (selectedTime) {
      if (selectEstimateTime == "today") {
        //current Date
        let midNightFormat = midNightTimeCheck();
        if (midNightFormat > formattedDate) {
          localStorage.setItem("orderTime", midNightFormat);
          localStorage.setItem("preOrder", midNightFormat);
          setEstimateShow(false);
          localStorage.setItem("orderType", "Today");
          setGetOrderType("Today");
        } else {
          localStorage.setItem("orderTime", formattedDate);
          localStorage.setItem("preOrder", formattedDate);
          setEstimateShow(false);
          setGetOrderType("Today");
        }
      } else {
        // let midNightFormat = midNightTimeCheck();
        // alert(midNightFormat)
        // if (midNightFormat) {
        //   localStorage.setItem(
        //     "orderTime",
        //     midNightFormat
        //   );
        //   localStorage.setItem(
        //     "preOrder",
        //     midNightFormat
        //   );
        //   setEstimateShow(false);
        //   setGetOrderType("Later");
        // }
        // else {
        // }
        localStorage.setItem(
          "orderTime",
          `${selectEstimateTime} ${selectedTime}`
        );
        localStorage.setItem(
          "preOrder",
          `${selectEstimateTime} ${selectedTime}`
        );
        setEstimateShow(false);
        setGetOrderType("Later");
      }
    } else {
      setEstimateError(true);
    }
  };
  const handleEstimateErrorClose = () => {
    setEstimateError(false);
  };

  function formatDate(dateString) {
    // Helper function to get a formatted date string from a Date object
    function formatDateObject(dateObj) {
      const year = dateObj.getFullYear();
      const month = dateObj.getMonth();
      const day = dateObj.getDate();

      // Array of month names (abbreviated)
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      // Array of weekday names (abbreviated)
      const weekdayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

      // Convert month number to month name and weekday number to weekday name
      const monthName = monthNames[month];
      const weekdayName = weekdayNames[dateObj.getDay()];

      // Return formatted date
      return `${weekdayName} ${monthName} ${day}`;
    }

    // Get today's date without time (for comparison)
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Helper function to compare dates
    function compareDates(date1, date2) {
      return date1.toDateString() === date2.toDateString();
    }

    // Parse the input date string
    const inputDate = new Date(dateString);

    // Compare with today and tomorrow
    if (compareDates(inputDate, today)) {
      return "Today";
    } else if (
      compareDates(inputDate, new Date(today.getTime() + 24 * 60 * 60 * 1000))
    ) {
      return "Tomorrow";
    } else {
      // Format as "weekday month year"
      return formatDateObject(inputDate);
    }
  }

  return (
    <>
      <Modal
        size="md"
        show={estimateShow}
        onHide={handleEstimateClose}
        className="estimateModalcheckout"
      >
        <Modal.Header
          className="estimateHeadercheckout"
          data-fus="fus-test-closebtn"
        >
          <Modal.Title
            id="example-modal-sizes-title-md estimateTitle"
            className="estimateTitle"
          >
            {/* {getOrderMode == "Delivery"
              ? " Schedule your delivery "
              : " Schedule your collection "} */}
            Choose a day
          </Modal.Title>
          {/* <span className="close-btn" onClick={handleEstimateClose}>
              <MdOutlineCancel />
            </span> */}
          <img
            src={closeiconnew}
            alt="closeicon"
            className="closeiconnew"
            onClick={handleEstimateClose}
          />
        </Modal.Header>
        <Modal.Body>
          <Swiper
            // navigation={{
            //   nextEl: '.swiper-button-next',
            //   prevEl: '.swiper-button-prev',
            // }}
            modules={[Pagination, Navigation]}
            className="mySwiper1"
            slidesPerView={6}
            spaceBetween={5}
            breakpoints={{
              0: {
                slidesPerView: 3,
              },
              400: {
                slidesPerView: 3,
              },
              639: {
                slidesPerView: 3,
              },
              865: {
                slidesPerView: 3,
              },
              1000: {
                slidesPerView: 3,
              },
              1500: {
                slidesPerView: 3,
              },
              1700: {
                slidesPerView: 3,
              },
            }}
            style={{
              boxShadow:
                "rgba(0, 0, 0, 0.1) 0px 0px 8px, rgba(0, 0, 0, 0.04) 0px 4px 4px",
              borderRadius: "15px",
            }}
          >
            {/* <div className="swiper-button-prev">
              <FaArrowLeft />
            </div>
            <div className="swiper-button-next">
              <FaArrowRight />
            </div> */}
            <SwiperSlide>
              {getOrderMode === "Delivery" ? (
                <Card
                  className={`estimateTimeCard ${
                    selectEstimateTime == "today" && deliveryTimesToday
                      ? "cardactive"
                      : ""
                  }`}
                  onClick={() => {
                    {
                      deliveryTimesToday && setSelectEstimateTime("today");
                      setSelectedTime(null);
                    }
                  }}
                  disabled={deliveryTimesToday ? false : true}
                  style={{
                    marginBottom: deliveryTimesToday ? "" : "0px",
                    textAlign: "center",
                  }}
                >
                  <Card.Body>
                    <Card.Title
                      onClick={() => {
                        {
                          deliveryTimesToday && setSelectEstimateTime("today");
                          setSelectedTime(null);
                        }
                      }}
                      style={{
                        marginBottom: deliveryTimesToday ? "" : "0px",
                        textAlign: "center",
                        cursor: "pointer",
                      }}
                    >
                      {" "}
                      <h6>
                        {" "}
                        {getOrderMode === "Delivery" ? "Today" : "Today"}
                      </h6>
                    </Card.Title>
                    {deliveryTimesToday == "" && (
                      <Card.Text
                        style={{
                          color: deliveryTimesToday ? "#000" : "#FF0000",
                          backgroundColor: deliveryTimesToday ? "" : "#FFF3F3",
                          marginBottom: deliveryTimesToday ? "" : "0px",
                          fontSize: deliveryTimesToday ? "" : "12px",
                          padding: deliveryTimesToday ? "" : "2px 4px",
                          textAlign: "center",
                          width: deliveryTimesToday ? "100%" : "auto",
                          borderRadius: "4px",
                        }}
                      >
                        Closed
                      </Card.Text>
                    )}
                  </Card.Body>
                </Card>
              ) : (
                <Card
                  className={`estimateTimeCard ${
                    selectEstimateTime == "today" && collectionTimesToday
                      ? "cardactive"
                      : ""
                  }`}
                  onClick={() => {
                    {
                      collectionTimesToday && setSelectEstimateTime("today");
                      setSelectedTime(null);
                    }
                  }}
                  style={{
                    marginBottom: collectionTimesToday ? "" : "0px",
                    textAlign: "center",
                  }}
                >
                  <Card.Body>
                    <Card.Title
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        {
                          collectionTimesToday &&
                            setSelectEstimateTime("today");
                          setSelectedTime(null);
                        }
                      }}
                    >
                      {" "}
                      <h6>
                        {" "}
                        {getOrderMode === "Delivery" ? "Today" : "Today"}
                      </h6>
                    </Card.Title>
                    {collectionTimesToday == "" && (
                      <Card.Text
                        style={{
                          color: collectionTimesToday ? "#000" : "#FF0000",
                          backgroundColor: collectionTimesToday
                            ? ""
                            : "#FFF3F3",
                          marginBottom: collectionTimesToday ? "" : "0px",
                          fontSize: collectionTimesToday ? "" : "12px",
                          padding: collectionTimesToday ? "" : "2px 4px",
                        }}
                      >
                        Closed
                      </Card.Text>
                    )}
                  </Card.Body>
                </Card>
              )}
            </SwiperSlide>

            {getOrderMode === "Delivery" ? (
              <>
                {preOrderTimeTable &&
                  preOrderTimeTable?.Delivery &&
                  preOrderTimeTable.Delivery.later &&
                  Object.entries(preOrderTimeTable.Delivery.later).map(
                    ([v, times]) => {
                      const deliveryDate = formatDate(v);
                      const parts = deliveryDate.split(" ");
                      const firstPart = parts[0]; // "Sun"
                      const secondPart = parts.slice(1).join(" "); // "Jul 7"
                      console.log(deliveryDate);
                      return (
                        <SwiperSlide>
                          <Card
                            className={`estimateTimeCard ${
                              selectEstimateTime == v && times
                                ? "cardactive"
                                : ""
                            }`}
                            onClick={() => {
                              {
                                times && setSelectEstimateTime(v);
                                setSelectedTime(null);
                              }
                            }}
                            disabled={times ? false : true}
                          >
                            <Card.Body>
                              <Card.Title></Card.Title>
                              <Card.Text
                                style={{ marginBottom: times ? "" : "0px" }}
                              >
                                {firstPart}
                                {times && secondPart && `(${secondPart})`}
                              </Card.Text>
                              {/* {times &&
                              <p>{secondPart}</p>
                            } */}
                              {times == "" && (
                                <Card.Text
                                  style={{
                                    color: times ? "#000" : "#FF0000",
                                    backgroundColor: times ? "" : "#FFF3F3",
                                    marginBottom: times ? "" : "0px",
                                    fontSize: times ? "" : "12px",
                                    padding: times ? "" : "2px 4px",
                                  }}
                                >
                                  Closed
                                </Card.Text>
                              )}
                            </Card.Body>
                          </Card>
                        </SwiperSlide>
                      );
                    }
                  )}
              </>
            ) : (
              <>
                {preOrderTimeTable &&
                  preOrderTimeTable?.Collection &&
                  preOrderTimeTable.Collection.later &&
                  Object.entries(preOrderTimeTable.Collection.later).map(
                    ([v, times]) => {
                      const collectionDate = formatDate(v);
                      const parts = collectionDate?.split(" ");
                      const firstPart = parts[0]; // "Sun"
                      // console.log("firstPartfirstPart", firstPart);

                      const secondPart = parts?.slice(1)?.join(" "); // "Jul 7"
                      return (
                        <SwiperSlide>
                          <Card
                            className={`estimateTimeCard ${
                              selectEstimateTime == v && times
                                ? "cardactive"
                                : ""
                            }`}
                            onClick={() => {
                              {
                                times && setSelectEstimateTime(v);
                                setSelectedTime(null);
                              }
                            }}
                            disabled={times ? false : true}
                          >
                            <Card.Body>
                              <Card.Title></Card.Title>
                              <Card.Text
                                style={{
                                  marginBottom: times ? "" : "0px",
                                  cursor: "pointer",
                                }}
                              >
                                {" "}
                                {firstPart}
                                {times && secondPart && `(${secondPart})`}
                              </Card.Text>
                              {/* {times &&
                              <p>{secondPart}</p>
                            } */}
                              {times == "" && (
                                <Card.Text
                                  style={{
                                    color: times ? "#000" : "#FF0000",
                                    backgroundColor: times ? "" : "#FFF3F3",
                                    marginBottom: times ? "" : "0px",
                                    fontSize: times ? "" : "12px",
                                    padding: times ? "" : "2px 4px",
                                  }}
                                >
                                  Closed
                                </Card.Text>
                              )}
                            </Card.Body>
                          </Card>
                        </SwiperSlide>
                      );
                    }
                  )}
              </>
            )}
          </Swiper>
          <div
            className="estimateTimetable border-bottom"
            data-fus="fus-test-timedateattribute"
          >
            {isLoadingTimes ? (
              <div className="skeleton-wrapper">
                {[...Array(4)].map((_, i) => (
                  <div className="skeleton-time-slot" key={i}></div>
                ))}
              </div>
            ) : getOrderMode === "Delivery" ? (
              selectEstimateTime == "today" ? (
                <>
                  {preOrderTimeTable &&
                  preOrderTimeTable?.Delivery &&
                  preOrderTimeTable.Delivery.today
                    ? preOrderTimeTable.Delivery.today
                        .split(",")
                        .map((v, i) => {
                          const addMinutes = (timeString, minutesToAdd) => {
                            // Split the time string into hours and minutes
                            const [hours, minutes] = timeString
                              .split(":")
                              .map(Number);

                            // Convert hours and minutes to total minutes
                            let totalMinutes = hours * 60 + minutes;

                            // Add the minutes to total minutes
                            totalMinutes += minutesToAdd;

                            // Calculate new hours and minutes
                            let newHours = Math.floor(totalMinutes / 60) % 24; // Ensure it wraps around correctly
                            let newMinutes = totalMinutes % 60;

                            // Handle negative totalMinutes (if minutesToAdd is negative)
                            if (totalMinutes < 0) {
                              newHours = (newHours + 24) % 24;
                              newMinutes = (newMinutes + 60) % 60;
                            }

                            // Format the new time
                            const formattedHours = String(newHours).padStart(
                              2,
                              "0"
                            );
                            const formattedMinutes = String(
                              newMinutes
                            ).padStart(2, "0");

                            // Return the formatted time string
                            return `${formattedHours}:${formattedMinutes}`;
                          };

                          function formatTime(timeString) {
                            const [hours, minutes] = timeString
                              ?.split(":")
                              ?.map(Number);

                            const hours12 = (hours % 12 || 12)
                              ?.toString()
                              ?.padStart(2, "0");
                            const ampm = hours >= 12 ? "PM" : "AM";

                            return `${hours12}:${minutes
                              ?.toString()
                              ?.padStart(2, "0")} ${ampm}`;
                          }

                          const endTime = addMinutes(v, 5);
                          const startTime = v;
                          const startTimeAmPM = formatTime(startTime);
                          const endTimeAmPm = formatTime(endTime);
                          return (
                            <>
                              <div
                                className="estimateTiming"
                                onClick={() => setSelectedTime(v)}
                              >
                                {/* <IoIosClock /> */}
                                {v && v !== "closed" ? (
                                  <>
                                    {v !== "No Pre-order" ? (
                                      <label onClick={() => setSelectedTime(v)}>
                                        {startTimeAmPM} - {endTimeAmPm}
                                      </label>
                                    ) : (
                                      <label>No Pre-order</label>
                                    )}
                                  </>
                                ) : (
                                  "null"
                                )}

                                {v && v !== "No Pre-order" && v !== "closed" ? (
                                  <>
                                    <input
                                      name="selectaddtype"
                                      type="radio"
                                      label="Home"
                                      id={i}
                                      checked={selectedTime === v}
                                      onChange={() => setSelectedTime(v)}
                                    />
                                  </>
                                ) : null}
                              </div>
                            </>
                          );
                        })
                    : null}
                </>
              ) : (
                <>
                  {preOrderTimeTable &&
                    preOrderTimeTable?.Delivery &&
                    preOrderTimeTable.Delivery.later &&
                    Object.entries(preOrderTimeTable?.Delivery?.later)
                      .filter(
                        ([date1, time1]) =>
                          selectEstimateTime && date1 === selectEstimateTime
                      )
                      .map(([date, times]) => {
                        return (
                          <div key={date}>
                            {times.split(",").length
                              ? times.split(",").map((v, i) => {
                                  const addMinutes = (
                                    timeString,
                                    minutesToAdd
                                  ) => {
                                    // Split the time string into hours and minutes
                                    const [hours, minutes] = timeString
                                      .split(":")
                                      .map(Number);

                                    // Convert hours and minutes to total minutes
                                    let totalMinutes = hours * 60 + minutes;

                                    // Add the minutes to total minutes
                                    totalMinutes += minutesToAdd;

                                    // Calculate new hours and minutes
                                    let newHours =
                                      Math.floor(totalMinutes / 60) % 24; // Ensure it wraps around correctly
                                    let newMinutes = totalMinutes % 60;

                                    // Handle negative totalMinutes (if minutesToAdd is negative)
                                    if (totalMinutes < 0) {
                                      newHours = (newHours + 24) % 24;
                                      newMinutes = (newMinutes + 60) % 60;
                                    }

                                    // Format the new time
                                    const formattedHours = String(
                                      newHours
                                    ).padStart(2, "0");
                                    const formattedMinutes = String(
                                      newMinutes
                                    ).padStart(2, "0");

                                    // Return the formatted time string
                                    return `${formattedHours}:${formattedMinutes}`;
                                  };

                                  function formatTime(timeString) {
                                    const [hours, minutes] = timeString
                                      ?.split(":")
                                      ?.map(Number);

                                    const hours12 = (hours % 12 || 12)
                                      ?.toString()
                                      ?.padStart(2, "0");
                                    const ampm = hours >= 12 ? "PM" : "AM";

                                    return `${hours12}:${minutes
                                      ?.toString()
                                      ?.padStart(2, "0")} ${ampm}`;
                                  }

                                  const endTime = addMinutes(v, 5);
                                  const startTime = v;
                                  const startTimeAmPM = formatTime(startTime);
                                  const endTimeAmPm = formatTime(endTime);
                                  return (
                                    <>
                                      <div
                                        className="estimateTiming"
                                        onClick={() => setSelectedTime(v)}
                                      >
                                        {/* <IoIosClock /> */}
                                        {v ? (
                                          <>
                                            {v !== "No Pre-order later" ? (
                                              <label
                                                onClick={() =>
                                                  setSelectedTime(v)
                                                }
                                              >
                                                {startTimeAmPM} - {endTimeAmPm}
                                              </label>
                                            ) : (
                                              <label>No Pre-order later</label>
                                            )}
                                          </>
                                        ) : (
                                          "null"
                                        )}

                                        {v && v !== "No Pre-order later" && (
                                          <input
                                            name="selectaddtype"
                                            type="radio"
                                            label="Home"
                                            id={i}
                                            checked={selectedTime == v}
                                            onChange={() => setSelectedTime(v)}
                                          />
                                        )}
                                      </div>
                                    </>
                                  );
                                })
                              : null}
                          </div>
                        );
                      })}
                </>
              )
            ) : selectEstimateTime == "today" ? (
              <>
                {preOrderTimeTable &&
                preOrderTimeTable?.Collection &&
                preOrderTimeTable.Collection.today
                  ? preOrderTimeTable.Collection.today
                      .split(",")
                      .map((v, i) => {
                        const addMinutes = (timeString, minutesToAdd) => {
                          // Split the time string into hours and minutes
                          const [hours, minutes] = timeString
                            .split(":")
                            .map(Number);

                          // Convert hours and minutes to total minutes
                          let totalMinutes = hours * 60 + minutes;

                          // Add the minutes to total minutes
                          totalMinutes += minutesToAdd;

                          // Calculate new hours and minutes
                          let newHours = Math.floor(totalMinutes / 60) % 24; // Ensure it wraps around correctly
                          let newMinutes = totalMinutes % 60;

                          // Handle negative totalMinutes (if minutesToAdd is negative)
                          if (totalMinutes < 0) {
                            newHours = (newHours + 24) % 24;
                            newMinutes = (newMinutes + 60) % 60;
                          }

                          // Format the new time
                          const formattedHours = String(newHours).padStart(
                            2,
                            "0"
                          );
                          const formattedMinutes = String(newMinutes).padStart(
                            2,
                            "0"
                          );

                          // Return the formatted time string
                          return `${formattedHours}:${formattedMinutes}`;
                        };
                        function formatTime(timeString) {
                          const [hours, minutes] = timeString
                            ?.split(":")
                            ?.map(Number);

                          const hours12 = (hours % 12 || 12)
                            ?.toString()
                            ?.padStart(2, "0");
                          const ampm = hours >= 12 ? "PM" : "AM";

                          return `${hours12}:${minutes
                            ?.toString()
                            ?.padStart(2, "0")} ${ampm}`;
                        }

                        const endTime = addMinutes(v, 5);
                        const startTime = v;
                        const startTimeAmPM = formatTime(startTime);
                        const endTimeAmPm = formatTime(endTime);
                        return (
                          <>
                            <div
                              className="estimateTiming"
                              onClick={() => setSelectedTime(v)}
                            >
                              {/* <IoIosClock /> */}

                              {v && v !== "closed" ? (
                                <>
                                  {v !== "No Pre-order" ? (
                                    <label onClick={() => setSelectedTime(v)}>
                                      {startTimeAmPM} - {endTimeAmPm}
                                    </label>
                                  ) : (
                                    <label>No Pre-order</label>
                                  )}
                                </>
                              ) : (
                                "null"
                              )}

                              {v && v !== "No Pre-order" && v !== "closed" ? (
                                <>
                                  <input
                                    name="selectaddtype"
                                    type="radio"
                                    label="Home1"
                                    id={i}
                                    checked={selectedTime === v}
                                    onChange={() => setSelectedTime(v)}
                                  />
                                </>
                              ) : null}
                            </div>
                          </>
                        );
                      })
                  : null}
              </>
            ) : (
              <>
                {preOrderTimeTable &&
                  preOrderTimeTable?.Collection &&
                  preOrderTimeTable.Collection.later &&
                  Object.entries(preOrderTimeTable?.Collection?.later)
                    .filter(
                      ([date1, time1]) =>
                        selectEstimateTime && date1 == selectEstimateTime
                    )
                    .map(([date, times]) => {
                      return (
                        <div key={date}>
                          {times
                            ? times.split(",").map((v, i) => {
                                const date1 = date; // Define date1 here
                                const addMinutes = (
                                  timeString,
                                  minutesToAdd
                                ) => {
                                  // Split the time string into hours and minutes
                                  const [hours, minutes] = timeString
                                    .split(":")
                                    .map(Number);

                                  // Convert hours and minutes to total minutes
                                  let totalMinutes = hours * 60 + minutes;

                                  // Add the minutes to total minutes
                                  totalMinutes += minutesToAdd;

                                  // Calculate new hours and minutes
                                  let newHours =
                                    Math.floor(totalMinutes / 60) % 24; // Ensure it wraps around correctly
                                  let newMinutes = totalMinutes % 60;

                                  // Handle negative totalMinutes (if minutesToAdd is negative)
                                  if (totalMinutes < 0) {
                                    newHours = (newHours + 24) % 24;
                                    newMinutes = (newMinutes + 60) % 60;
                                  }

                                  // Format the new time
                                  const formattedHours = String(
                                    newHours
                                  ).padStart(2, "0");
                                  const formattedMinutes = String(
                                    newMinutes
                                  ).padStart(2, "0");

                                  // Return the formatted time string
                                  return `${formattedHours}:${formattedMinutes}`;
                                };

                                function formatTime(timeString) {
                                  const [hours, minutes] = timeString
                                    ?.split(":")
                                    ?.map(Number);

                                  const hours12 = (hours % 12 || 12)
                                    ?.toString()
                                    ?.padStart(2, "0");
                                  const ampm = hours >= 12 ? "PM" : "AM";

                                  return `${hours12}:${minutes
                                    ?.toString()
                                    ?.padStart(2, "0")} ${ampm}`;
                                }

                                const endTime = addMinutes(v, 5);
                                const startTime = v;
                                const startTimeAmPM = formatTime(startTime);
                                const endTimeAmPm = formatTime(endTime);

                                return (
                                  <div
                                    key={i}
                                    className="estimateTiming"
                                    onClick={() => setSelectedTime(v)}
                                  >
                                    {/* <IoIosClock /> */}
                                    {v ? (
                                      <>
                                        {v !== "No Pre-order later" ? (
                                          <label
                                            onClick={() => setSelectedTime(v)}
                                          >
                                            {startTimeAmPM} - {endTimeAmPm}
                                          </label>
                                        ) : (
                                          <label>No Pre-order later</label>
                                        )}
                                      </>
                                    ) : (
                                      "null"
                                    )}
                                    {v && v !== "No Pre-order later" && (
                                      <input
                                        name="selectaddtype"
                                        type="radio"
                                        label="Home"
                                        id={i}
                                        data-attr={date}
                                        checked={
                                          date == selectEstimateTime
                                            ? selectedTime == v
                                            : ""
                                        }
                                        onChange={() => setSelectedTime(v)}
                                      />
                                    )}
                                  </div>
                                );
                              })
                            : null}
                        </div>
                      );
                    })}
              </>
            )}
          </div>
          <div className="scheduleBtncheckout">
            <Button
              variant="secondary"
              className="estimateCancelBtn"
              onClick={handleEstimateClose}
              style={{ background: "#EEEEEE !important" }}
              data-fus="fus-test-cancelbtn"
            >
              Cancel
            </Button>
            <Button
              variant="secondary"
              onClick={handleScheduleChange}
              disabled={selectedTime ? false : true}
              data-fus="fus-test-schedulebtn"
            >
              Schedule
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      {estimateError && (
        <Modal
          show={estimateError}
          onHide={handleEstimateErrorClose}
          className="estimateErrorModal"
        >
          <Modal.Header
            closeButton
            className="estimateErrorHeader"
          ></Modal.Header>
          <Modal.Body>
            <Modal.text className="estimateErrorText">
              Choose new {getOrderMode == "Delivery" ? "Delivery" : "Pickup"}{" "}
              time
            </Modal.text>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

const ListPage = ({
  getListpage,
  isLoading,
  error,
  response,
  userData,
  getCuisines,
  listCusinesReducer,
  getListPageClear,
  getCuisinesClear,
  getFilterClear,
}) => {
  const {
    getOrderMode,
    getOrderTime,
    setOrderTime,
    setFooterLoading,
    footerLoading,
    reslimit,
    setReslimit,
    restaurantData,
    setRestaurantData,
    hasFetchedData,
    updateHasFetchedData,
  } = OrderFlow();
  const location = useLocation();
  const canonicalUrl = `${window.location.origin}${location.pathname}`;
  const [OrderType, setOrderType] = useState(getOrderMode);
  const [selectedFilter, setselectedFilter] = useState(null);
  const [selectedSort, setSelectedSort] = useState(null);
  const [selectedOffers, setSelectedOffers] = useState([]);
  const [selectedDietary, setSelectedDietary] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [cuisinefilter, setCuisineFilter] = useState([]);
  const [selectedHygiene, setSelectedHygiene] = useState(null);
  const [TextSearchData, setTextSearchData] = useState(null);
  const [cuisinesLimit, setCuisinesLimit] = useState(1);
  const [selectimeStatus, setSelectimeStatus] = useState(false);
  const [tabStatus, setTabStatus] = useState(null);
  const [estimateShow, setEstimateShow] = useState(false);
  const [selectedTime, setSelectedTime] = useState(null);
  const [preOrderTimeTable, setPreOrderTimeTable] = useState(null);
  const [getorderType, setGetOrderType] = useState("ASAP");
  const preOrderTimePart1 = localStorage.getItem("orderTime");
  const preOrderTimePart = preOrderTimePart1?.trim();
  const exitOrderTimePart = preOrderTimePart?.split(" ")[1];
  const exitOrderDatePart1 = preOrderTimePart?.split(" ")[0];
  //old date format check
  const dateParts = exitOrderDatePart1?.includes("-")
    ? exitOrderDatePart1
    : exitOrderDatePart1?.split("/");

  const exitOrderDatePart = dateParts
    ? dateParts?.includes("-")
      ? dateParts
      : `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`
    : "";

  // Check if the date is valid and parse it.

  const dateZone = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  let formatToday = new Date()
    ?.toLocaleString("en-GB", dateZone)
    .replace(",", "");
  const dateString = formatToday?.replaceAll("/", "-");
  const parts = dateString?.split("-"); // Split the string by '-'
  const formattedDateE = `${parts[2]}-${parts[1]}-${parts[0]}`;
  const [selectEstimateTime, setSelectEstimateTime] = useState(
    exitOrderDatePart
      ? exitOrderDatePart == formattedDateE
        ? "today"
        : exitOrderDatePart
      : "today"
  );

  let orderTypeForApi = "0";
  if (OrderType === "Delivery") {
    orderTypeForApi = "0";
  } else if (OrderType === "Collection") {
    orderTypeForApi = "1";
  } else if (OrderType === "Dine In") {
    orderTypeForApi = "2";
  }
  const postCode = localStorage.getItem("storePostcode");
  const navigate = useNavigate();
  if (postCode === "" || postCode === null) {
    navigate("/");
  }

  useEffect(() => {
    if (getOrderTime === null || getOrderTime === "") {
      const currentTime = new Date().toLocaleString("en-GB", {
        timeZone: "Europe/London",
      });
      const [datePart, timePart] = currentTime.split(", ");
      const [hours, minutes] = timePart.split(":");
      const formattedTime = `${hours}:${minutes}`;
      localStorage.setItem("orderTime", `${datePart} ${formattedTime}`);
      setOrderTime(`${datePart} ${formattedTime}`);
    }
  }, [setOrderTime, getOrderTime]);

  const now = new Date();
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  };
  const orderTime = now.toLocaleString("en-GB", options).replace(",", "");

  let customerId = "";
  if (userData) {
    customerId = userData.customerId;
  }
  useEffect(() => {
    // console.log(restaurantData);
    if (reslimit === 0) {
      getListPageClear();
      getCuisinesClear();
      getFilterClear();
      setRestaurantData([]);
      setReslimit(1);
    }
  }, [reslimit]);
  const handleFooter = () => {
    // console.log(footerLoading);
    setFooterLoading(false);
  };
  useEffect(() => {
    handleFooter();
  }, []);
  useEffect(() => {
    if (footerLoading === false) {
      setTimeout(() => {
        setFooterLoading(true);
      }, 2000);
    }
  }, [footerLoading]);
  const formData = useMemo(() => {
    const inputDate = orderTime; // Your input date string
    const dateParts = inputDate.split(" ")[0].split("/"); // Split the date into parts
    const timePart = inputDate.split(" ")[1]; // Get the time part

    // Create a Date object with the parts
    const dateObject = new Date(
      `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}T${timePart}`
    );

    // Format the date in the desired format
    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const day = String(dateObject.getDate()).padStart(2, "0");
    const hour = String(dateObject.getHours()).padStart(2, "0");
    const minute = String(dateObject.getMinutes()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day} ${hour}:${minute}`;

    return {
      post_code: postCode,
      order_mode: orderTypeForApi,
      order_time: formattedDate,
      customer_id: customerId,
      favourite: false,
      limit: reslimit === 0 ? 1 : reslimit,
    };
  }, [postCode, orderTypeForApi, orderTime, customerId]);

  const dispatch = useDispatch();
  useEffect(() => {
    if (!hasFetchedData) {
      const newFormData = { ...formData };
      delete newFormData.limit;
      // console.log(newFormData);
      dispatch(getFilter(newFormData));
      getListpage(formData);
      getCuisines(formData);
      updateHasFetchedData(true);
    }
  }, [formData, orderTime, hasFetchedData]);

  // const onSkeleton = () => {
  //   if (isLoading) {
  //     return <ListSkeleton />;
  //   }
  // };

  // useEffect(() => {
  //   onSkeleton();
  // }, [isLoading]);

  const apiCall = async (dataMode) => {
    const inputDate = orderTime; // Your input date string
    const dateParts = inputDate.split(" ")[0].split("/"); // Split the date into parts
    const timePart = inputDate.split(" ")[1]; // Get the time part

    // Create a Date object with the parts
    const dateObject = new Date(
      `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}T${timePart}`
    );

    // Format the date in the desired format
    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const day = String(dateObject.getDate()).padStart(2, "0");
    const hour = String(dateObject.getHours()).padStart(2, "0");
    const minute = String(dateObject.getMinutes()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day} ${hour}:${minute}`;

    if (dataMode === "restaurant") {
      let form_data = {
        post_code: postCode,
        order_mode: orderTypeForApi,
        order_time: formattedDate,
        customer_id: customerId,
        favourite: false,
        limit: reslimit + 1,
      };
      setReslimit((prev) => prev + 1);
      getListpage(form_data);
    } else {
      let cuisines_data = {
        post_code: postCode,
        order_mode: orderTypeForApi,
        order_time: formattedDate,
        customer_id: customerId,
        favourite: false,
        limit: cuisinesLimit + 1,
      };
      setCuisinesLimit((prev) => prev + 1);
      getCuisines(cuisines_data);
    }
  };

  useEffect(() => {
    const clientId = localStorage.getItem("clientId");
    // console.log(clientId);
    const formData = { client_id: clientId };
    getOrderTimingDetail(formData)
      .then((response) => {
        // console.log(response);
        if (response.status === true) {
          // console.log(response.status);
          setPreOrderTimeTable(response?.message);
        } else {
          // Handle the case where response.status is false
          console.log(response);
        }
      })
      .catch((error) => {
        // Handle the case where response.status is false
        console.log("Error: " + error);
      });
  }, []);

  const restaurantStatus = response?.response?.restaurantFilter || "";
  const hygiene = response?.response?.hygieneRatingFilter || "";
  const offerBanners = response?.response?.offerBanners || "";
  const offerFilters = response?.response?.offerFilters || "";
  const dietaryFilter = response?.response?.dietaryFilter || "";
  const cuisines = listCusinesReducer?.response || " ";

  return (
    <>
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
      {/* {isLoading ? (
        <ListSkeleton />
      ) : (
      )} */}
        <section className="listpage" id="scrollList">
          <Container>
            <ContextWidthProvider.Provider
              value={{
                selectedOffers,
                setSelectedOffers,
                selectedSort,
                setSelectedSort,
                OrderType,
                setOrderType,
                selectedFilter,
                setselectedFilter,
                selectedDietary,
                setSelectedDietary,
                selectedCategories,
                setSelectedCategories,
                selectedHygiene,
                setSelectedHygiene,
                TextSearchData,
                setTextSearchData,
                cuisinefilter,
                setCuisineFilter,
                estimateShow,
                setEstimateShow,
                getorderType,
                setGetOrderType,
                selectedTime,
                setSelectedTime,
                selectEstimateTime,
                setSelectEstimateTime,
                exitOrderTimePart,
                exitOrderDatePart,
                selectimeStatus,
                setSelectimeStatus,
                tabStatus,
                setTabStatus,
                preOrderTimeTable,
                setPreOrderTimeTable,
              }}
            >
              <Row>
                <Col
                  xs={12}
                  sm={12}
                  md={4}
                  lg={4}
                  xl={3}
                  xxl={3}
                  className="px-0"
                >
                  <div className="isStickyS">
                    <Sidebar
                      restaurantStatus={restaurantStatus}
                      hygiene={hygiene}
                      cuisines={cuisines}
                      offerBanners={offerBanners}
                      offerFilters={offerFilters}
                      dietaryFilter={dietaryFilter}
                      updateHasFetchedData={updateHasFetchedData}
                      postCode={postCode}
                      setReslimit={setReslimit}
                      setCuisinesLimit={setCuisinesLimit}
                    />
                  </div>
                </Col>
                <Col xs={12} sm={12} md={8} lg={8} xl={9} xxl={9}>
                  <FilterList
                    restaurantStatus={restaurantStatus}
                    hygiene={hygiene}
                    offerBanners={offerBanners}
                    offerFilters={offerFilters}
                    dietaryFilter={dietaryFilter}
                    postCode={postCode}
                    apiCall={apiCall}
                  />
                  <Showcart restaurantStatus={restaurantStatus} />
                </Col>
              </Row>
              {estimateShow && (
                <EstimateModal
                  estimateShow={estimateShow}
                  setEstimateShow={setEstimateShow}
                  selectedTime={selectedTime}
                  setSelectedTime={setSelectedTime}
                  selectEstimateTime={selectEstimateTime}
                  setSelectEstimateTime={setSelectEstimateTime}
                  exitOrderDatePart={exitOrderDatePart}
                  exitOrderTimePart={exitOrderTimePart}
                  setGetOrderType={setGetOrderType}
                />
              )}
            </ContextWidthProvider.Provider>
          </Container>
        </section>
    </>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state?.getListpage?.isLoading,
  response: state?.listFilterReducer,
  listCusinesReducer: state?.listCusinesReducer,
  error: state?.getListpage?.error,
  userData: state?.userdata?.userData,
});

const mapDispatchToProps = {
  getListpage,
  getCuisines,
  getListPageClear,
  getCuisinesClear,
  getFilterClear,
};

export default connect(mapStateToProps, mapDispatchToProps)(ListPage);
